import type { Range } from 'api/System/types'
import { Ranges } from 'api/System/types'
import { moment } from 'locale'
import type { Action } from 'redux'
import { combineReducers } from 'redux'
import { isBeforeNoonAtAppStart, momentValidDateFormat } from 'utils'

import { TypeAnalysis } from './constants'
import { CHANGE_DATE, SELECT_DATE_RANGE, TOGGLE_DATE_PICKER_DIALOG } from './constants'
import type { ClosedPeriods } from './types'

interface Payload extends Action {
  payload: {
    range?: Range
    closedPeriod?: ClosedPeriods
    dateCurrent?: string
    dateCompared?: string
    typeAnalysis: TypeAnalysis
  }
}

const initialDate = moment()
  .add(isBeforeNoonAtAppStart ? -1 : 0, 'days')
  .format(momentValidDateFormat)

function dateCurrent(state = initialDate, { payload, type }: Payload) {
  switch (type) {
    case CHANGE_DATE:
      return moment(payload.dateCurrent!).format(momentValidDateFormat)

    case SELECT_DATE_RANGE:
      return payload.dateCurrent ? moment(payload.dateCurrent).format(momentValidDateFormat) : state

    default:
      return state
  }
}

function dateCompared(state = null, { payload, type }: Payload) {
  switch (type) {
    case CHANGE_DATE:
      return moment(payload.dateCompared || state).format(momentValidDateFormat)

    default:
      return state
  }
}

function isOpen(state = false, { type }: Action) {
  switch (type) {
    case TOGGLE_DATE_PICKER_DIALOG:
      return !state

    case SELECT_DATE_RANGE:
      return false

    default:
      return state
  }
}

function range(state: Range | null = null, { payload, type }: Payload) {
  switch (type) {
    case SELECT_DATE_RANGE:
      return payload.typeAnalysis === TypeAnalysis.perDay || !payload.range ? null : payload.range

    case CHANGE_DATE:
      return null

    default:
      return state
  }
}

function typeAnalysis(state: TypeAnalysis = TypeAnalysis.perDay, { payload, type }: Payload) {
  switch (type) {
    case SELECT_DATE_RANGE:
      return payload.typeAnalysis || TypeAnalysis.perDay

    case CHANGE_DATE:
      return TypeAnalysis.perDay

    default:
      return state
  }
}

function closedPeriod(state: ClosedPeriods = Ranges.WEEK, { payload, type }: Payload) {
  switch (type) {
    case SELECT_DATE_RANGE:
      return payload.closedPeriod || Ranges.WEEK

    default:
      return state
  }
}

export default combineReducers({
  closedPeriod,
  dateCurrent,
  dateCompared,
  isOpen,
  range,
  typeAnalysis,
})
